module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAALxJREFUKJGN0stKgzEUBODP0jyCCqWbgo/mQkofUXBTV9YfL8VWik/hyguMm/wSs1APDGHmDMm5hBphGs7DPqRiX7WpNsI8PDTGHndhPprLH+YRt6EIq66EXcN34aXhK2FohKewCDdhHc7CockPwkf39BBOwmnYdrnXCd78jM96HuG9y02ETXPDOhyHq1rWopb53biwbITLcN319Nzw5TjW+3+MdRPKuItZePzFvA2zftslXHRzP9SvUUbfF2V41mYwOHoBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/errorVerm.png
// module id = 139
// module chunks = 0